import { z } from "zod";

export const DTOLiveblocksAuthResponse = z.object({
    token: z.string(),
})

export type DTOLiveblocksAuthResponse = z.infer<typeof DTOLiveblocksAuthResponse>;
